<template>
  <!--- Sidemenu -->
  <div id="sidebar-menu">
    <!-- Left Menu Start -->
    <ul class="metismenu list-unstyled" id="side-menu">
      <li class="menu-title" data-key="t-menu-hotspot">Menu Hotspot</li>
      <li v-show="tienePermiso('modulos', 'vista')">
        <router-link class="side-nav-link-ref" :to="{ name: 'modulos' }">
          <eva-icon class="icon nav-icon" name="grid-outline"></eva-icon>
          <span class="menu-item" data-key="t-modulos">Modulos</span>
        </router-link>
      </li>

      <li v-show="tienePermiso('tableroHotspot', 'vista')">
        <router-link class="side-nav-link-ref" :to="{ name: 'tableroHotspot' }">
          <eva-icon class="icon nav-icon" name="home-outline"></eva-icon>
          <span class="menu-item" data-key="t-inicio">Inicio</span>
        </router-link>
      </li>

      <li v-show="tienePermiso('fichasHotspot', 'vista')">
        <router-link class="side-nav-link-ref" :to="{ name: 'fichasHotspot' }">
          <eva-icon class="icon nav-icon" name="layers-outline"></eva-icon>
          <span class="menu-item" data-key="t-fichas">Fichas</span>
        </router-link>
      </li>

      <li v-show="tienePermiso('generarVenderHotspot', 'vista')">
        <router-link class="side-nav-link-ref" :to="{ name: 'generarVenderHotspot' }">
          <eva-icon class="icon nav-icon" name="keypad-outline"></eva-icon>
          <span class="menu-item" data-key="t-generar-vender">Generar y vender</span>
        </router-link>
      </li>

      <li v-show="tienePermiso('hotspots', 'vista')">
        <router-link class="side-nav-link-ref" :to="{ name: 'hotspots' }">
          <eva-icon class="icon nav-icon" name="wifi-outline"></eva-icon>
          <span class="menu-item" data-key="t-hotspots">Hotspots</span>
        </router-link>
      </li>

      <li v-show="tienePermiso('perfilesHotspot', 'vista')">
        <router-link class="side-nav-link-ref" :to="{ name: 'perfilesHotspot' }">
          <eva-icon class="icon nav-icon" name="pantone-outline"></eva-icon>
          <span class="menu-item" data-key="t-perfiles-usuario">Perfiles de usuario</span>
        </router-link>
      </li>

      <li v-show="tienePermiso('listadoRouters', 'vista')">
        <router-link class="side-nav-link-ref" :to="{ name: 'listadoRouters' }">
          <eva-icon class="icon nav-icon" name="hash-outline"></eva-icon>
          <span class="menu-item" data-key="t-routers">Routers</span>
        </router-link>
      </li>

      <!-- <li v-show="tienePermiso('clientesHotspot', 'vista')">
        <router-link class="side-nav-link-ref" :to="{ name: 'clientesHotspot' }">
          <span class="menu-item" data-key="t-clientes-hotspot">Clientes</span>
        </router-link>
      </li> -->

      <!-- <li v-show="tienePermiso('puntoVentaHotspot', 'vista')">
        <router-link class="side-nav-link-ref" :to="{ name: 'puntoVentaHotspot' }">
          <span class="menu-item" data-key="t-puntos-venta">Puntos de venta</span>
        </router-link>
      </li> -->

      <li v-show="tienePermiso('vendedoresHotspot', 'vista')">
        <router-link class="side-nav-link-ref" :to="{ name: 'vendedoresHotspot' }">
          <eva-icon class="icon nav-icon" name="people-outline"></eva-icon>
          <span class="menu-item" data-key="t-vendedores">Vendedores</span>
        </router-link>
      </li>

      <li v-show="tienePermiso('portalCautivoHotspot', 'vista')">
        <router-link class="side-nav-link-ref" :to="{ name: 'portalCautivoHotspot' }">
          <eva-icon class="icon nav-icon" name="layout"></eva-icon>
          <span class="menu-item" data-key="t-layouts">Layouts</span>
        </router-link>
      </li>

      <!-- <li v-show="tienePermiso('cortesCajaHotspot', 'vista')">
        <router-link class="side-nav-link-ref" :to="{ name: 'cortesCajaHotspot' }">
          <span class="menu-item" data-key="t-cortes-caja">Cortes de caja</span>
        </router-link>
      </li> -->

      <li v-show="tienePermiso('listadoSitios', 'vista')">
        <router-link class="side-nav-link-ref" :to="{ name: 'listadoSitios' }">
          <eva-icon class="icon nav-icon" name="pin"></eva-icon>
          <span class="menu-item" data-key="t-sitios_hotspot">Sitios</span>
        </router-link>
      </li>

      <li class="menu-title" data-key="t-sistem">Sistema</li>

      <li v-show="
          tienePermiso('ajustesGeneralesSistema', 'vista') ||
          tienePermiso('listadoUsuarios',  'vista') ||
          tienePermiso('ajustesSistema',   'vista') ||
          tienePermiso('acercaDe',         'vista')
        "
      >
        <a href="javascript: void(0);" class="has-arrow">
          <eva-icon class="icon nav-icon" name="settings-2-outline"></eva-icon>
          <span class="menu-item" data-key="t-sistema">Sistema</span>
        </a>
        <ul class="sub-menu" aria-expanded="false">
          <li v-show="tienePermiso('ajustesGeneralesSistema', 'vista')">
            <router-link class="side-nav-link-ref" :to="{ name: 'ajustesGeneralesSistema' }" data-key="t-ajustes-general">
              General
            </router-link>
          </li>
          <li v-show="tienePermiso('listadoUsuarios', 'vista')">
            <router-link class="side-nav-link-ref" :to="{ name: 'listadoUsuarios' }" data-key="t-usuarios">
              Usuarios
            </router-link>
          </li>
          <li v-show="$store.state.todo.nombre_empresa != 'PBRS' && tienePermiso('sistemaCuenta', 'vista')">
            <router-link class="side-nav-link-ref" :to="{ name: 'sistemaCuenta' }" data-key="t-cuenta">
              Cuenta
            </router-link>
          </li>
          <li v-show="tienePermiso('sistemaLog', 'vista')">
            <router-link class="side-nav-link-ref" :to="{ name: 'sistemaLog' }" data-key="t-log">
              Log
            </router-link>
          </li>
          <li v-show="tienePermiso('acercaDe', 'vista')">
            <router-link class="side-nav-link-ref" :to="{ name: 'acercaDe' }" data-key="t-acerca-de">
              Acerca de
            </router-link>
          </li>
          <li id="instalador" style="display: none;">
            <a href="javascript: void(0);" class="side-nav-link-ref" @click="instaladorArgus()">
              <span data-key="t-instalar-argusblack">Instalar ArgusBlack</span>
            </a>
          </li>
        </ul>
      </li>
    </ul>
  </div>
  <!-- Sidebar -->
</template>

<script>
export default {
  name: 'NavHotspot',
  props: {
    tienePermiso: {
      type: Function,
      requerid: true
    }
  },
  mounted: function() {
    var self = this

    if(window.deferredPrompt != null) {
      let instalador = document.getElementById('instalador')
      instalador.style.display = 'block'
    }
  },
  created() {
    var self = this
    window.addEventListener('beforeinstallprompt', (e) => {
      let instalador = document.getElementById('instalador')
      instalador.style.display = 'block'
      window.deferredPrompt = e
    })
  },
  methods: {
    instaladorArgus:function() {
      var self = this

      if (window.deferredPrompt !== null) {
        window.deferredPrompt.prompt()
        const { outcome } = window.deferredPrompt.userChoice
        if (outcome === 'accepted') {
          window.deferredPrompt = null
        }
      } else {
        iu.msg.warning("Debe de recargar la vista para cargar el instalador correctamente")
      }
    }
  }
}
</script>

<style scoped>
</style>